import { Box, IconButton } from "@mui/material";
import React from "react";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import DeleteIcon from "@mui/icons-material/Delete";


const SideBarActions = ({ undo, redo, deleteSelectedShape}) => {
	return (
		<Box
			position="fixed"
			left="0"
			top="40%"
			display="flex"
			flexDirection="column"
			alignItems="center"
			zIndex="tooltip"
		>
			<IconButton
				onClick={undo}
				color="primary"
				style={{ fontSize: "30px", margin: "10px 0" }}
			>
				<UndoIcon />
			</IconButton>
			<IconButton
				onClick={redo}
				color="primary"
				style={{ fontSize: "30px", margin: "10px 0" }}
			>
				<RedoIcon />
			</IconButton>
			<IconButton
				onClick={deleteSelectedShape}
				style={{ color: "gray", fontSize: "30px", margin: "10px 0" }}
			>
				<DeleteIcon />
			</IconButton>
		</Box>
	);
};

export default SideBarActions;
